import React from "react";
import { renderToStaticMarkup } from "react-dom/server";
import { InsRangeChartAxisLabel } from "./insRangeChartAxisLabel";
import { getDateQuarter, getDateString, getPreviousDate } from "common/date-utils";
import { getPrincipleDescription } from "common/un-principles-helper";
import { InsLabelValueTooltip } from "components/widgets/base/common/insLabelValueTooltip";
import { language } from "language/default";
const principlesText = language.en.widgets.principlesTable;
export const FormatUnPrinciplesTooltip = function FormatUnPrinciplesTooltip() {
    const labelValuePairs = [];
    labelValuePairs.push([principlesText.violationType, this.point.options.custom?.type || ""]);
    labelValuePairs.push([principlesText.violationSource, this.point.options.custom?.source || ""]);
    labelValuePairs.push([principlesText.startDate, getDateString(new Date(this.point.x))]);
    labelValuePairs.push([principlesText.endDate, this.point.x2 === this.series.xAxis.max ? principlesText.stillActive : getDateString(new Date(this.point.x2 || 0))]);
    return renderToStaticMarkup(React.createElement(InsLabelValueTooltip, { labelValuePairs: labelValuePairs }));
};
export const formatUnPrinciplesAxisLabels = (obj) => {
    const category = obj.value?.toString(), description = getPrincipleDescription(category);
    if (description) {
        return renderToStaticMarkup(React.createElement(InsRangeChartAxisLabel, { category: category, description: description }));
    }
    return category;
};
export const QuarterAxisLabelsFormatter = function QuarterAxisLabelsFormatter() {
    const firstDayOfQuarter = new Date(this.value), lastDayOfPreviousQuarter = getPreviousDate(firstDayOfQuarter), quarter = getDateQuarter(lastDayOfPreviousQuarter);
    return `Q${quarter}`;
};
export const YearAxisLabelsFormatter = function YearAxisLabelsFormatter() {
    const firstDayOfQuarter = new Date(this.value);
    return `${firstDayOfQuarter.getFullYear()}`;
};
